// extracted by mini-css-extract-plugin
export var actionButton = "_or-0";
export var actionMenuContainer = "_or-i";
export var bubble = "_or-2";
export var bubbleActionMenu = "_or-j";
export var bubbleContext = "_or-6";
export var bubbleItems = "_or-7";
export var customer = "_or-3";
export var divider = "_or-8";
export var fileList = "_or-9";
export var hiddenComment = "_or-o";
export var infoAbove = "_or-a";
export var internal = "_or-4";
export var lightActionButton = "_or-1";
export var link = "_or-b";
export var merchant = "_or-5";
export var message = "_or-c";
export var profilePicture = "_or-e";
export var quillToolbarContainer = "_or-f";
export var senderDate = "_or-g";
export var senderDateCustomer = "_or-h";
export var senderName = "_or-d";
export var time = "_or-k";
export var uploadedImage = "_or-l";
export var username = "_or-m";
export var xsmall = "_or-n";